// extracted by mini-css-extract-plugin
export default {"buyerTitle":"xAU8y4yQB29mjRNcrdNu__buyerTitle___","buyerTable":"wQNrb0ir05H2Ubf_mZgy__buyerTable___"};